<template>
  <div
    class="navbar-offcanvas"
    role="navigation"
    id="js-bootstrap-offcanvas-nav"
  >
    <div class="dashboard-nav__container">
      <ul class="sidemenu">
        <div class="mobile-logo" v-if="!$whitelabel && $vlastMode">
          <vlast-logo-full class="vlast-logo vlast-logo--full" />
        </div>
        <li
          class="sidemenu__item sidemenu__item--staple-top"
          v-if="!$userIsReportingAdmin"
        >
          <router-link
            tag="a"
            :to="{ name: 'dashboard', query: { src: 'menu' } }"
            class="sidemenu__link"
            exact
          >
            <i class="sidemenu__icon fa fa-home" />
            <span>Home</span>
          </router-link>
        </li>
        <li
          v-for="(link, index) in navigationItems"
          :key="link.id"
          @click="trackParent(link)"
          class="sidemenu__group"
          :class="{
            'sidemenu__group--cta': link.cta,
            'sidemenu__group--expanded': link.expanded || !link.heading,
            'sidemenu__group--active': isActive(index),
          }"
        >
          <div v-if="link.heading" class="sidemenu__heading">
            <button class="sidemenu__toggle" @click="toggleActive(index)">
              <span>{{ link.heading }}</span>
              <span class="sidemenu__toggle-icon"></span>
            </button>
          </div>
          <ul class="sidemenu__list">
            <li
              v-for="child in link.items"
              :key="child.id"
              @click.stop="trackChild(child)"
              class="sidemenu__item"
              :class="{ 'sidemenu__item--featured': child.featured }"
            >
              <router-link
                tag="a"
                :to="{ name: child.view }"
                class="sidemenu__link"
                :class="{
                  'sidemenu__link--child': link.items.length > 1 || link.heading
                }"
                exact
              >
                <span v-if="child.counter" class="sidemenu__counter">
                  {{ child.counter }}
                </span>
                <span>
                  {{ child.label }}
                </span>
                <i
                  v-if="child.icon"
                  class="fa sidemenu__icon"
                  :class="`fa-${child.icon}`"
                />
              </router-link>
            </li>
          </ul>
        </li>
        <li
          class="sidemenu__item sidemenu__item--staple-bottom sidemenu__item--visible-sm"
        >
          <router-link
            tag="a"
            :to="{ name: 'profile.show' }"
            class="sidemenu__link"
            exact
          >
            My Profile
          </router-link>
        </li>
        <li class="sidemenu__item sidemenu__item--staple-bottom" @click="trackChild({'view': 'logout'})">
          <router-link
            tag="a"
            :to="{ name: 'logout' }"
            class="sidemenu__link"
            exact
          >
            <i class="fa fa-window-close sidemenu__icon" />
            Logout
          </router-link>
        </li>
      </ul>

      <div class="sidemenu__helpbutton" v-if="!$vlastMode && $userIsClient">
        <help-button />
      </div>
    </div>
  </div>
</template>

<script>
import { publicUrl } from 'utils'
import { mapState } from 'vuex'
import navigation from '../mixins/navigation/index'
import VlastLogoFull from '../components/icons/VlastLogoFull'
import HelpButton from '../components/globals/HelpButton'
import { NavigationTracker } from 'mixins/analytics'

export default {
  components: {
    VlastLogoFull,
    HelpButton
  },
  data () {
    return {
      active: 0
    }
  },

  mixins: [navigation, NavigationTracker],

  computed: {
    ...mapState('clientConfig', ['client_config']),
    navigationItems () {
      const role = this.$userIsAdmin ? 'admin' : this.$user.role
      return this.navigation[role].filter(e => e.items.length !== 0)
    },

    newRequestUrl () {
      return publicUrl('request/welcome')
    },
    userCanImportTalent () {
      if (this.$userIsManager) {
        return this.$userIsActivated
      }
      if (this.$userIsClient || this.$userIsIntern) {
        return false
      }
      return true
    },
    userCanViewCalendar () {
      if (this.$userIsManager) {
        return this.$userIsActivated
      }
      if (this.$userIsClient || this.$userIsIntern) {
        return false
      }
      return true
    },

    userIsSales () {
      return this.$user.role === 'sales'
    },

    userCanViewBookings () {
      if (this.$userIsManager) {
        return this.$userIsActivated
      }

      return true
    },

    showNewRequestButton () {
      return !this.$vlastMode && this.$userIsClient
    },

    showVlastNewRequestButton () {
      return (
        this.$vlastMode &&
        (this.$userIsAdmin || this.$userIsClient)
      )
    },

    userCanViewThreads () {
      if (this.$userIsManager) {
        return this.$userIsActivated
      }
      return !this.$userIsIntern
    },

    userCanViewRequests () {
      if (this.$userIsManager) {
        return this.$userIsActivated
      }

      return true
    },

    userCanViewBillboard () {
      if (this.$userIsManager) {
        return this.$userIsActivated
      }

      return this.$userIsAdmin || this.$userIsTalent || this.$userIsSales
    },

    userCanViewTalentList () {
      if (this.$userIsManager) {
        return this.$userIsActivated
      }

      return this.$userIsAdmin || this.$userIsIntern || this.$userIsSales
    }
  },

  created () {
    if (!this.$userIsIntern && !this.$userIsReportingAdmin) {
      this.getUnreadCount()
      this.getUnreadCountMessaging()
    }
  },

  methods: {
    toggleActive (index) {
      this.active === index ? (this.active = null) : (this.active = index)
      this.isActive(index)
    },

    isActive (index) {
      return this.active === index
    },

    trackParent (link) {
      this.trackEvent(this.getNavigationSideMenuHeaderItem(link))
    },

    trackChild (child) {
      this.trackEvent(this.getNavigationSideMenuItem(child.view))
    }
  }
}
</script>
